/* eslint-disable max-len */
/* eslint-disable max-lines */
import { useMemo } from 'react'
import { useI18n } from '@popety_io/popety-io-lib'
import { Box, Typography } from '@mui/material'
import CollapseList from '../EstimateLandSummary/LandSummaryContent/CollapseList'
import { IHeatingAndHotWaterValues } from './Energy.types'

import HeatingAndHotWater from './HeatingAndHotWater'
import {
  AdditionHeatingKeys,
  AdditionHotWaterKeys,
  HeatingKeys,
  HotWaterKeys,
  getHWDefaultStates,
} from './utils'

const HeatingAndHotWaterSection = ({ data }: any) => {
  const { t } = useI18n()

  const values = useMemo<IHeatingAndHotWaterValues>(
    () => ({
      heater_generator: data?.heater_generator,
      power_source_heater: data?.power_source_heater,
      heater_datasource: data?.heater_datasource,
      last_update_timestamp_heater:
        data?.last_update_timestamp_heater?.split('T')[0],
      heater_water_generator: data?.heater_water_generator,
      power_source_water_heater: data?.power_source_water_heater,
      water_heater_datasource: data?.water_heater_datasource,
      last_update_timestamp_water_heater:
        data?.last_update_timestamp_water_heater?.split('T')[0],
      additional_heater_generator: data?.additional_heater_generator,
      power_source_additional_heater: data?.power_source_additional_heater,
      additional_heater_datasource: data?.additional_heater_datasource,
      last_update_timestamp_additional_heater:
        data?.last_update_timestamp_additional_heater?.split('T')[0],

      additional_heater_water_generator:
        data?.additional_heater_water_generator,
      power_source_additional_water_heater:
        data?.power_source_additional_water_heater,
      additional_water_heater_datasource:
        data?.additional_water_heater_datasource,
      last_update_timestamp_additional_water_heater:
        data?.last_update_timestamp_additional_water_heater?.split('T')[0],
    }),
    [data],
  )

  return (
    <div>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBlock: '16px',
        }}
      >
        <Typography
          variant="h6"
          sx={{
            marginBottom: '4px',
            fontSize: '1.1rem',
            textTransform: 'uppercase',
          }}
        >
          {t('building.energy.Chauffage et eau chaude')}
        </Typography>
      </Box>
      <CollapseList
        sx={{
          backgroundColor: '#F9F9F9',
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          padding: '7px 6px',
          gap: '24px',
          '@media (max-width: 991px)': {
            gridTemplateColumns: '1fr',
          },
        }}
        min={2}
        moreKey="common.system.Voir système supplémentaire"
        items={
          [
            <HeatingAndHotWater
              title={t('building.energy.Système de chauffage le plus puissant')}
              isLoading={false}
              data={getHWDefaultStates(values, HeatingKeys)}
            />,
            <HeatingAndHotWater
              title={t(
                'building.energy.Système pour leau chaude le plus puissant',
              )}
              isLoading={false}
              data={getHWDefaultStates(values, HotWaterKeys)}
            />,
            <HeatingAndHotWater
              title={t('building.energy.Système de chauffage supplémentaire')}
              isLoading={false}
              data={getHWDefaultStates(values, AdditionHeatingKeys)}
            />,
            <HeatingAndHotWater
              data={getHWDefaultStates(values, AdditionHotWaterKeys)}
              title={t(
                'building.energy.Système pour leau chaude supplémentaire',
              )}
              isLoading={false}
            />,
          ] as any
        }
      />
    </div>
  )
}

export default HeatingAndHotWaterSection
